import { parseStyleVar } from 'helpers/styleVariables';
import useViewportWidth from 'hooks/useViewportWidth';
import styleVars from 'styles/shared/jsVariables';

export const BP_1 = parseStyleVar(styleVars.bp1); // 550px
export const BP_2 = parseStyleVar(styleVars.bp2); // 850px
export const BP_3 = parseStyleVar(styleVars.bp3); // 1100px

const useScreenSizeConstants = () => {
  const { width } = useViewportWidth();

  const isUnderBp1 = width < BP_1;
  const isUnderBp2 = width < BP_2;
  const isUnderBp3 = width < BP_3;

  const isAtLeastBp1 = width >= BP_1;
  const isAtLeastBp2 = width >= BP_2;
  const isAtLeastBp3 = width >= BP_3;

  return {
    width,
    isUnderBp1,
    isUnderBp2,
    isUnderBp3,
    isAtLeastBp1,
    isAtLeastBp2,
    isAtLeastBp3,
  };
};

export default useScreenSizeConstants;
